import React, { useEffect, useState, useRef, forwardRef } from 'react';
import { LiveService } from '../services/live-service';
import { Link } from 'react-router-dom';
import AddLivetag from '../components/add-livetag';
import Loading from "../components/layouts/loading";
import TitleGrows from "../components/title-grows";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DeleteLiveTagModal from '../components/delete-livetag-modal';

//Material
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import MuiTableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { withStyles } from '@mui/styles';

//Snackbar, Menu
//import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  borderRadius: '6px',
  border: '1px solid #fff',
  boxShadow: 24,
  p: 4,
};

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const MAX_LENGTH = 80;

const TableCell = withStyles(theme => ({
  root: {
    height: 50,
    padding: 8,
  }
}))(MuiTableCell);

const columns = [
  { id: 'id', label: 'ID', width: 60, minWidth: 60, align: 'left', fweight: 'bold' },
  {
    id: 'name',
    label: 'NAME',
    minWidth: 180,
    align: 'left',
    format: (value) => value.toLocaleString('it-IT'),
  },
  {
    id: 'slug',
    label: 'SLUG',
    minWidth: 180,
    align: 'left',
    format: (value) => value.toLocaleString('it-IT'),
  },
  {
    id: 'description',
    label: 'DESCRIPTION',
    minWidth: 200,
    align: 'left',
    format: (value) => value.length > MAX_LENGTH ? `${value.toLocaleString('it-IT').substring(0, MAX_LENGTH)}...` : value.toLocaleString('it-IT'),
  },
  {
    id: 'count_assigned',
    label: 'ASSIGNED',
    minWidth: 120,
    align: 'center',
    txtAlign: 'center'
  }
];

export default function LiveTags() {

  const searchIDRef = useRef();
  const searchNameRef = useRef();
  const searchSlugRef = useRef();
  const radioAscDesc = useRef();
  const arrOrdering = ['id', 'name', 'slug'];

  const [tagId, setTagId] = useState(0);
  const [tagList, setTagList] = useState([]);
  const [lcount, setLcount] = useState(0);
  const [searchID, setSearchID] = useState('');
  const [searchName, setSearchName] = useState('');
  const [searchSlug, setSearchSlug] = useState('');
  const [ordering, setOrdering] = useState(arrOrdering[0]);
  const [ascDesc, setAscDesc] = useState('-');
  const [forceUpdate, setForceUpdate] = useState(false);
  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
    message: '',
    severity: 'success',
    ahduration: 3000,
    instructions: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const { openSB, vertical, horizontal, message, severity, ahduration, instructions } = state;

  //Mui Modal Add livetag
  const [open, setOpen] = useState(false);
  const handleOpenAddLT = () => setOpen(true);
  const handleCloseAddLT = () => setOpen(false);

  //Material
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [showDeleteTag, setShowDeleteTag] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    async function fetchData() {
      setForceUpdate(false);
      setIsLoading(true);
      /* let alltag = await LiveService.getListTag(
          {
              name__icontains: inputValue
          }); */
      const alltag = await LiveService.getListTag(
        {
          page: page + 1,
          page_size: rowsPerPage,
          id: searchID,
          name__icontains: searchName,
          slug__icontains: searchSlug,
          ordering: `${ascDesc}${ordering}`
        }
      );
      setTagList(alltag.results);
      setLcount(alltag.count);
      setIsLoading(false);
    }
    fetchData();
  }, [page, rowsPerPage, searchID, searchName, searchSlug, ordering, ascDesc, forceUpdate]);

  function handleUpdateAddLiveTag(tag, wasAdded) {
    //console.log('Tag di ritorno da Add Livetag', tag);

    if (wasAdded === false) {
      //Se in errore
      setState({
        openSB: true,
        vertical: 'top',
        horizontal: 'center',
        message: 'Non è stato possibile salvare il nuovo tag!',
        severity: 'error',
        ahduration: null,
        instructions: null
      });
      return;
    }

    handleCloseAddLT();
    setForceUpdate(true);

    if (wasAdded === true) {
      setState({
        openSB: true,
        vertical: 'top',
        horizontal: 'center',
        message: 'Salvato correttamente!',
        severity: 'success',
        ahduration: 2000,
        instructions: null
      })
    }
  }

  /* const handleOpen = (newState) => () => {
      setState({ open: true, ...newState });
  }; */

  const handleClose = () => {
    setState({ ...state, openSB: false });
  };

  function keyPress(event, filter) {
    if (event.key === 'Enter') {
      switch (filter) {
        case 'id':
          setSearchID(searchIDRef.current.value);
          setSearchName('');
          setSearchSlug('');
          break;
        case 'name':
          setSearchName(searchNameRef.current.value);
          setSearchID('');
          setSearchSlug('');
          break;
        case 'slug':
          setSearchSlug(searchSlugRef.current.value);
          setSearchID('');
          setSearchName('');
          break;
        default:
          ResetAll();
      }
      setPage(0);
    }
  }

  function ResetAll() {
    searchIDRef.current.value = '';
    searchNameRef.current.value = '';
    searchSlugRef.current.value = '';
    setPage(0);
    setSearchID('');
    setSearchName('');
    setSearchSlug('');
    setOrdering(arrOrdering[0]);
    setAscDesc('-');
  }

  function deleteTag(_tagId) {
    setTagId(_tagId);
    setShowDeleteTag(true);
  }

  const [anchorEl, setAnchorEl] = useState(null);
  const mopen = Boolean(anchorEl);
  const handleOrderClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  function handleOrderClose() {
    setAnchorEl(null);
  }

  function handleUpdate(wasDeleted) {
    //Conferma di chiusura del modal DeleteTagModal
    if (wasDeleted === true) {
      setState({
        openSB: true,
        vertical: 'top',
        horizontal: 'center',
        message: 'Eliminato correttamente!',
        severity: 'success',
        ahduration: 1500,
        instructions: null
      })
      ResetAll();
      setForceUpdate(true);
    }
    if (wasDeleted === false) {
      //Se in errore
      setState({
        openSB: true,
        vertical: 'top',
        horizontal: 'center',
        message: 'Errore, non è stato possibile eliminare il tag!',
        severity: 'error',
        ahduration: null,
        instructions: null
      });
    }
    setShowDeleteTag(false);
  }

  return (
    <>
      <div className="row">
        <div className="col-6 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-left">
          <TitleGrows txtTitle={'Lives Tags'} />
        </div>
        <div className="col-6 col-md-6 col-lg-6 col-xl-6 d-flex"
          style={{ justifyContent: "right", overflow: "hidden", paddingRight: "20px" }}>
          <IconButton onClick={handleOpenAddLT} edge="end" aria-label="add">
            <FontAwesomeIcon
              icon={['fas', 'plus']}
              title="Aggiungi un tag"
              size={'1x'}
              color={'#198754'}
            />
          </IconButton>
        </div>
      </div>
      <>
        {isLoading && <Loading />}
        <main>
          <div className="container-fluid" style={{ minHeight: "46px" }}>
            <div className="row">
              <div className="col-12 col-md-12 col-lg-2 col-xl-2 d-flex justify-content-center" style={{ minWidth: "160px" }}>
                <div className="input-group">
                  <input type="text" className="form-control" placeholder="Search ID"
                    style={{ padding: "6px" }}
                    onKeyDown={(e) => keyPress(e, "id")}
                    ref={searchIDRef}
                    aria-label="Search tag id" aria-describedby="button-search" />
                  <IconButton className="cancel-input" edge="end" aria-label="delete-id" title=""
                    id="button-delete-id" onClick={() => { searchIDRef.current.value = ''; setSearchID('') }} >
                    <FontAwesomeIcon icon={['fas', 'times']} size={'1x'} color={'lightgray'} />
                  </IconButton>
                  <button className="btn btn-primary" type="button" id="button-search-id"
                    onClick={() => { setSearchID(searchIDRef.current.value); setPage(0) }}>
                    <FontAwesomeIcon icon={['fas', 'search']} size={'1x'} color={'white'} />
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-2 col-xl-2 d-flex justify-content-center" style={{ minWidth: "160px" }}>
                <div className="input-group">
                  <input type="text" className="form-control" placeholder="Search Name"
                    style={{ padding: "6px" }}
                    onKeyDown={(e) => keyPress(e, "name")}
                    ref={searchNameRef}
                    aria-label="Search tag name" aria-describedby="button-search" />
                  <IconButton className="cancel-input" edge="end" aria-label="delete-name" title=""
                    id="button-delete-name" onClick={() => { searchNameRef.current.value = ''; setSearchName('') }} >
                    <FontAwesomeIcon icon={['fas', 'times']} size={'1x'} color={'lightgray'} />
                  </IconButton>
                  <button className="btn btn-primary" type="button" id="button-search-name"
                    onClick={() => { setSearchName(searchNameRef.current.value); setPage(0) }}>
                    <FontAwesomeIcon icon={['fas', 'search']} size={'1x'} color={'white'} />
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-2 col-xl-2 d-flex justify-content-center" style={{ minWidth: "160px" }}>
                <div className="input-group">
                  <input type="text" className="form-control" placeholder="Search Slug"
                    style={{ padding: "6px" }}
                    onKeyDown={(e) => keyPress(e, "slug")}
                    ref={searchSlugRef}
                    aria-label="Search tag slug" aria-describedby="button-search" />
                  <IconButton className="cancel-input" edge="end" aria-label="delete-slug" title=""
                    id="button-delete-slug" onClick={() => { searchSlugRef.current.value = ''; setSearchSlug('') }} >
                    <FontAwesomeIcon icon={['fas', 'times']} size={'1x'} color={'lightgray'} />
                  </IconButton>
                  <button className="btn btn-primary" type="button" id="button-search-slug"
                    onClick={() => { setSearchSlug(searchSlugRef.current.value); setPage(0); }}>
                    <FontAwesomeIcon icon={['fas', 'search']} size={'1x'} color={'white'} />
                  </button>
                </div>
              </div>

              <div className="col-12 col-md-12 col-lg-3 col-xl-3 d-flex justify-content-center">
                <div>
                  <button type="button" className="btn btn-secondary" data-bs-display="static" aria-expanded="false"
                    onClick={handleOrderClick} style={{ minWidth: "160px", padding: "6px 20px 6px 20px" }} >
                    Sort by: {ordering}
                  </button>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={mopen}
                    onClose={handleOrderClose}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                  >
                    {arrOrdering.map((e, i) => {
                      return <MenuItem key={i} onClick={() => { handleOrderClose(); setOrdering(e); setPage(0); }}>{e}</MenuItem>
                    })}
                  </Menu>
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-2 col-xl-2 d-flex justify-content-center"
              >
                <div className="ab">
                  <input type="radio" value="" name="ordv" onChange={(e) => { setAscDesc(e.target.value); setPage(0); }} ref={radioAscDesc} checked={ascDesc === ''} /> Asc
                  <span style={{ margin: "0 8px" }}></span>
                  <input type="radio" value="-" name="ordv" onChange={(e) => { setAscDesc(e.target.value); setPage(0); }} ref={radioAscDesc} checked={ascDesc === '-'} /> Desc
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-1 col-xl-1 d-flex justify-content-center">
                <button onClick={() => { ResetAll() }}
                  className="badge btn-primary btn-sm text-wrap" >
                  Reset
                </button>
              </div>
            </div>
          </div>

          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ height: 754 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell sx={{ bgcolor: "#212529", color: "white" }}
                        key={column.id}
                        align={column.align}
                        style={{ width: column.width, minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))
                    }
                    <TableCell sx={{ textAlign: "center", bgcolor: "#212529", color: "white", minWidth: "92px" }}>
                      TOT: {lcount}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody >
                  <>
                    {(tagList?.length > 0) ?
                      tagList.map((row, key) => {
                        return (
                          <TableRow hover tabIndex={-1} key={key} sx={{ height: 64 }}>
                            {columns.map((column) => {
                              const value = row[column.id];
                              return (
                                <TableCell key={column.id} sx={{ align: column.align, fontWeight: column.fweight, textAlign: column.txtAlign }}>
                                  {column.format && typeof value === 'string'
                                    ? column.format(value)
                                    :
                                    column.id === 'count_assigned' && typeof value === 'number'
                                      ?
                                      value === 0
                                        ?
                                        <>
                                          <div className="row">
                                            <div className="col-6" style={{ margin: "auto 0", textAlign: "right" }}></div>
                                            <div className="col-6" style={{ margin: "inherit", textAlign: "left" }}>
                                              <IconButton edge="end" aria-label="delete" title="Zero assegnazioni (Elimina il tag)"
                                                id="button-delete-tag" onClick={() => deleteTag(row.id)}
                                                style={{ minWidth: "40px" }}>
                                                <FontAwesomeIcon icon={['fas', 'times']} size={'1x'} color={'#dc3545'} />
                                              </IconButton>
                                            </div>
                                          </div>
                                        </>
                                        :
                                        <>
                                          <div className="row">
                                            <div className="col-6" style={{ margin: "auto 0", textAlign: "right" }}>
                                              {value}
                                            </div>
                                            <div className="col-6" style={{ margin: "inherit", textAlign: "left" }}>
                                              <Link to={{ pathname: "/liveview-by-tag-id/" + row.id }}
                                                key={row.id}
                                              >
                                                <IconButton edge="end" aria-label="external-link" title="Vai a Lives/Videos relative"
                                                  id="button-external" style={{ minWidth: "40px" }}>
                                                  <FontAwesomeIcon icon={['fas', 'external-link-alt']} size={'1x'} color={'#6c757d'} />
                                                </IconButton>
                                              </Link>
                                            </div>
                                          </div>
                                        </>
                                      : value
                                  }
                                </TableCell>
                              );
                            })}
                            <TableCell sx={{ textAlign: "center" }}>
                              <Link to={{ pathname: "/livetagdetail/" + row.id }}
                                key={row.id}
                              >
                                <FontAwesomeIcon icon={['fas', 'edit']} size={'2x'} color={'#0D6EFD'} title={'Dettaglio'} />
                              </Link>
                            </TableCell>
                          </TableRow>
                        )
                      }) :
                      <TableRow>
                        <TableCell colSpan={5} >
                          <h6 style={{ width: "100%", textAlign: "center", margin: "6px" }}>
                            Nessun risultato trovato
                          </h6>
                        </TableCell>
                      </TableRow>
                    }
                  </>
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              //count={liveviewList.length}
              count={lcount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </main>

        {showDeleteTag && <DeleteLiveTagModal id={tagId} onUpdate={handleUpdate}></DeleteLiveTagModal>}

        <Snackbar open={openSB} autoHideDuration={ahduration} onClose={handleClose}
          anchorOrigin={{ vertical, horizontal }} >
          <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
            <div style={{ textAlign: "center" }}>{message}</div>
            {instructions ?
              <Alert severity="info" sx={{ margin: "10px 0 0 0" }}>
                <div>
                  Istruzioni:
                </div>
                {instructions}
              </Alert>
              : ''}
          </Alert>
        </Snackbar>
        <Modal
          aria-labelledby="livetag-modal-title"
          aria-describedby="livetag-modal-description"
          open={open}
          onClose={handleCloseAddLT}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <Typography id="livetag-modal-title" variant="h6" component="h2">
                New Tag
              </Typography>
              <AddLivetag onUpdate={handleUpdateAddLiveTag} />
              <div style={{ textAlign: "center" }}>
                <button type="button" className="btn btn-secondary"
                  style={{ minWidth: '6rem', marginTop: '24px' }}
                  onClick={handleCloseAddLT}>
                  Chiudi
                </button>
              </div>
            </Box>
          </Fade>
        </Modal>
      </>
    </>
  );
}
